"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/contracts/pTON/constants.ts
var pTON_VERSION = {
  v1: "v1",
  v2_1: "v2_1"
};



exports.pTON_VERSION = pTON_VERSION;
//# sourceMappingURL=chunk-I4SOZEKK.cjs.map